<template>
  <div :style="offsetStyle" class="sub-nav-sidebar">
    <div class="sub-nav-sidebar-inner-scroll">
      <div class="menu-title">เมนูจัดการโครงการ</div>
      <ul class="sub-nav-sidebar-items">
        <li :class="{ active: $route.name.match('projects.show.proposal*') }">
          <router-link :to="{ name: 'projects.show.proposal.basic', params: $route.params }" active-class="active">
            <span class="icon"><font-awesome-icon icon="file-signature" /></span>
            <span>แบบขออนุมัติโครงการ</span>
          </router-link>
          <ul class="child-items">
            <li>
              <router-link
                :to="{ name: 'projects.show.proposal.basic', params: $route.params }"
                :class="{ active: $route.name.match('projects.show.proposal.basic*') }"
                exact-active-class="active"
              >
                <span>ข้อมูลพื้นฐานโครงการ</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'projects.show.proposal.planning', params: $route.params }"
                :class="{ active: $route.name.match('projects.show.proposal.planning*') }"
                exact-active-class="active"
              >
                <span>แผนการดำเนินงาน</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'projects.show.proposal.budget', params: $route.params }"
                :class="{ active: $route.name.match('projects.show.proposal.budget*') }"
                exact-active-class="active"
              >
                <span>งบประมาณ</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'projects.show.proposal.outcome', params: $route.params }"
                :class="{ active: $route.name.match('projects.show.proposal.outcome*') }"
                exact-active-class="active"
              >
                <span>เป้าหมาย/ตัวชี้วัดความสำเร็จ</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'projects.show.proposal.other', params: $route.params }"
                :class="{ active: $route.name.match('projects.show.proposal.other*') }"
                exact-active-class="active"
              >
                <span>ข้อมูลเพิ่มเติม</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'projects.show.proposal.documents', params: $route.params }"
                :class="{ active: $route.name.match('projects.show.proposal.documents*') }"
                exact-active-class="active"
              >
                <span>เอกสารเพิ่มเติม</span>
              </router-link>
            </li>
          </ul>
        </li>
        <!-- <li>
          <a href="#">
            <span class="icon"><font-awesome-icon icon="id-badge" /></span>
            <span>ลงทะเบียนและตรวจบัตร</span>
          </a>
          <ul class="child-items">
            <li><a href="#"><span>ข้อมูลกิจกรรม</span></a></li>
            <li><a href="#"><span>ตั้งค่าการลงทะเบียน/ตรวจบัตร</span></a></li>
            <li><a href="#"><span>รายชื่อผู้เข้าร่วม</span></a></li>
            <li><a href="#"><span>แบบประเมินกิจกรรม</span></a></li>
          </ul>
        </li> -->
        <li :class="{ active: $route.name.match('projects.show.change-requests*') }">
          <router-link :to="{ name: 'projects.show.change-requests.index', params: $route.params }" active-class="active">
            <span class="icon"><font-awesome-icon icon="edit" /></span>
            <span>รายการเปลี่ยนแปลงแก้ไข</span>
          </router-link>
        </li>
        <li :class="{ active: $route.name.match('projects.show.evaluation*') }">
          <router-link :to="{ name: 'projects.show.evaluation.index', params: $route.params }">
            <span class="icon"><font-awesome-icon icon="chart-bar" /></span>
            <span>สรุปและประเมินผลโครงการ</span>
          </router-link>
          <ul class="child-items">
            <li>
              <router-link :to="{ name: 'projects.show.evaluation.index', params: $route.params }" exact-active-class="active">
                <span>สรุปผล</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'projects.show.evaluation.participantList', params: $route.params }" active-class="active">
                <span>รายชื่อผู้เข้าร่วมโครงการ</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'projects.show.evaluation.expenses', params: $route.params }" active-class="active">
                <span>ค่าใช้จ่าย</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'projects.show.evaluation.gallery', params: $route.params }" active-class="active">
                <span>ภาพกิจกรรม</span>
              </router-link>
            </li>
            <li v-if="$auth.user().role === 'coordinator' && project.status === 'DraftForCloseProjectApproval'">
              <router-link :to="{ name: 'projects.show.evaluation.satisfactionQuestionnaire', params: $route.params}" active-class="active">
                <span>แบบสอบถามความพึงพอใจ</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li :class="{ active: $route.name.match('projects.show.history*') }">
          <router-link :to="{ name: 'projects.show.history', params: $route.params }" active-class="active">
            <span class="icon"><font-awesome-icon icon="history" /></span>
            <span>ประวัติการพิจารณา</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      //
    }
  },
  computed: {
    isSidebarMinimized () { return this.$store.state.layout.isSidebarMinimized },
    isSidebarEnabled () { return this.$store.state.layout.isSidebarEnabled },
    offsetStyle () {
      if (!this.isSidebarEnabled) { return { left: 0 } }
      return this.isSidebarMinimized ? { left: '45px' } : { left: '220px' }
    },
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) }
  },
  methods: {
    toggleNavbar () { this.isMinimized = !this.isMinimized }
  }
}
</script>

<style lang="scss" scoped>
$background-color: $gray-800;
$border-color: #e5e5e5;
$active-color: lighten($brand-color, 20%);

.sub-nav-sidebar {
  position: fixed;
  left: 220px;
  top: 152px;
  bottom: 0;
  width: 240px;
  background-color: $background-color;
  border-right: 1px solid $border-color;
  z-index: 1;
}

.sub-nav-sidebar-inner-scroll {
  height: 100%;
  width: 100%;
  overflow: auto;
}

ul.sub-nav-sidebar-items {
  list-style: none;
  padding: 0;
  margin: 0;

  & > li {
    border-bottom: 1px solid $gray-900;

    a {
      display: block;
      width: 100%;
      padding: 9px 10px 9px 18px;
      color: $gray-100;
      font-weight: 500;

      &:hover {
        text-decoration: none;
        background-color: rgba(0,0,0,0.12);
      }

      .icon {
        font-size: 0.8rem;
        top: -2px;
        position: relative;
        display: inline-block;
        text-align: center;
        margin-right: 3px;
      }
    }

    &.active {
      & > a {
        color: $active-color;
        font-weight: 500;
      }
    }

    ul.child-items {
      margin: 0;
      padding: 0;

      li {
        border-bottom: none;

        a {
          padding: 5px 5px 5px 40px;
          font-size: 0.85rem;
          font-weight: 300;

          &.active {
            color: $active-color;
            background-color: rgba(0,0,0,0.05);
          }
        }
      }
    }
  }
}

.menu-title {
  background-color: $gray-900;
  color: $gray-600;
  padding: 5px 5px 5px 15px;
  font-size: 0.7rem;
  letter-spacing: 0.5px;
  font-weight: 500;
}
</style>
